(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("SettingsController", SettingsController);

  /** @ngInject */
  function SettingsController(
    deviceActions,
    $scope,
    $state,
    $stateParams,
    SettingsViewModel,
    broker,
    webSocketsStore,
    layoutActions
  ) {
    var vm = this;
    // _webSocketStoreConnectedChangeHandler = subscribeToSocket,
    // _onFeedChangedHandler = refreshDeviceFeed;

    vm.facility = new SettingsViewModel($stateParams.id);

    vm.cancelChanges = function() {
      goToDetailsPage(vm.facility.deviceSerial);
    };

    vm.saveChanges = function() {
      var actuationData = vm.facility.getActuationData();

      deviceActions
        .actuate(actuationData.deviceSerial, actuationData.data)
        .then(
          function() {
            goToDetailsPage(vm.facility.deviceSerial);
          },
          function() {
            //todo error handling
          }
        );
    };

    vm.disableInput = function(value) {
      return value === null || value === "";
    };

    function init() {
      layoutActions.showLoader();

      deviceActions
        .getDevice(vm.facility.deviceSerial)
        .then(function(deviceJson) {
          layoutActions.hideLoader();

          vm.facility.refresh(deviceJson, deviceJson.modbusType);

          // subscribeToSocket();
          // webSocketsStore.on(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
          // webSocketsStore.on(webSocketsStore.events.DEVICE_FEED_CHANGE, _onFeedChangedHandler);
          // webSocketsStore.on(webSocketsStore.events.DEVICE_ACTUATOR_CHANGE, deviceActuatorChange);
        });

      $scope.$on("$destroy", function() {
        vm.facility.destroy();
        // webSocketsStore.off(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        // webSocketsStore.off(webSocketsStore.events.DEVICE_FEED_CHANGE, _onFeedChangedHandler);
        // webSocketsStore.off(webSocketsStore.events.DEVICE_ACTUATOR_CHANGE, deviceActuatorChange);
      });
    }

    // function subscribeToSocket () {
    //   if (webSocketsStore.isConnected()) {
    //     var serialArray = [];
    //     serialArray.push(vm.facility.deviceSerial);

    //     broker.subscribeToDeviceChanges(serialArray);
    //     broker.subscribeToFeedChanges(serialArray);
    //     broker.subscribeToActuatorChanges(serialArray);
    //   }
    // };

    // function deviceConectionChange () {
    //   $timeout(function () {
    //     console.log("device je konektovan");
    //   }, 50);
    // };

    // function refreshDeviceFeed () {
    //   $timeout(function () {
    //     console.log("feed podatak se promenio");
    //   }, 50);
    // };

    // function deviceActuatorChange(){
    //   $timeout(function () {
    //     console.log("aktuator podatak se promenio");
    //   }, 50);
    // };

    init();

    function goToDetailsPage(deviceSerial) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: deviceSerial
      });
    }
  }
})();
